import restorationPaths from "./global-landing-restoration-paths.json";

/**
 * Small route-only mirror of the server's restoration manifest. Keep this
 * exact-path set separate from the authored CMS/source records so the browser
 * receives only the 347 paths, never the multi-megabyte content manifest.
 */
export const GLOBAL_LANDING_RESTORATION_PATHS: readonly string[] = Object.freeze(restorationPaths);

const restorationPathSet = new Set(GLOBAL_LANDING_RESTORATION_PATHS);

/**
 * Normalize URL encoding and a trailing slash for route membership only.
 * Path casing and suffix content stay exact; this never rewrites the URL.
 */
export function normalizeGlobalLandingRestorationPath(path: string): string {
  const withLeadingSlash = path.startsWith("/") ? path : `/${path}`;
  let decoded = withLeadingSlash;
  try {
    decoded = decodeURI(withLeadingSlash);
  } catch {
    // Keep malformed escapes unchanged; they cannot alias a known source URL.
  }
  return decoded.length > 1 ? decoded.replace(/\/+$/, "") : decoded;
}

export function isKnownGlobalLandingRestorationPath(path: string): boolean {
  return restorationPathSet.has(normalizeGlobalLandingRestorationPath(path));
}